import { Model } from 'pinia-orm';
import { BelongsTo, Num, Str } from 'pinia-orm/dist/decorators';
import Claim from './Claim';
import Package from './Package';
import ProjectSupplier from './ProjectSupplier';
/* --- user header --- */
/* --- end user header --- */

export default class PackageClaim extends Model {
  static entity = 'App\\Models\\PackageClaim';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare package_id: number;
  @Num(0)
  declare claim_id: number;
  @Num(0)
  declare project_supplier_id: number;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  // relations
  @BelongsTo(() => Package, 'package_id', 'id')
  declare package: Package;
  @BelongsTo(() => Claim, 'claim_id', 'id')
  declare claim: Claim;
  @BelongsTo(() => ProjectSupplier, 'project_supplier_id', 'id')
  declare project_supplier: ProjectSupplier;
  /* --- user code --- */
  /* --- end user code --- */
}
